<script>
import axios from 'axios'
import adminTable from './mixins/adminTable'
export default
{
    mixins: [ adminTable ],

    methods:
    {
        fetch()
        {
            axios.get(process.env.API_URL + this.url).then(res => {
                this.data = res.data
                this.updateData()
            }).catch(e => {})
        },

    },

    data()
    {
        return {
            url: '/v1/admin/questions',
            tableName: 'tableQuestions',
            data: [],
            emptyModel: { name: null, name_en: null, order: 0, description: null, description_en: null },
            columns: [ 'id', 'name', 'created_at', 'order',  'actions' ],
            options: {
                headings: {
                    actions: this.$t('TABLE.ACTIONS'),
                    created_at: this.$t('GENERAL.CREATED_AT'),
                    updated_at: this.$t('GENERAL.UPDATED_AT'),
                    name: this.$t('GENERAL.NAME'),
                    description: this.$t('GENERAL.DESCRIPTION'),
                    order: this.$t('MENUS.ORDER'),
                },
                perPage: 25,
                saveState: true,
                highlightMatches: true,
                filterByColumn: true,
                columnsDropdown: true,
                toMomentFormat: true,
                filterable: ['name', 'order', 'created_at', 'updated_at'],
            },
        }
    },

}
</script>

<template>
    <div class="container-fluid">
        <mv-modal ref="form">
            <span slot="header">{{ $t('MENU.QUESTIONS') }}</span>
            <mv-question-form :model="model" :edit="formEdit" @save="saveForm"></mv-question-form>
            <div slot="footer">
                <button class="btn btn-success" @click="closeForm">{{ $t('GENERAL.CANCEL') }}</button>
                <button class="btn btn-primary" @click="saveForm">{{ $t('GENERAL.SAVE') }}</button>
            </div>
        </mv-modal>
        <div class="panel panel-primary">
            <div class="panel-heading">
                <div class="row">
                    <div class="col-sm-10">
                        <h4>{{ $t('MENU.QUESTIONS') }}</h4>
                    </div>
                    <div class="col-sm-2 text-right">
                        <button class="btn btn-xs btn-warning" @click="newModel">
                            <icon name="plus"></icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="panel-body">
                <v-client-table :data="data" :columns="columns" :options="options" :name="tableName" ref="table">
                    <div slot="actions" slot-scope="props" class="text-center">
                        <button class="btn btn-xs btn-warning" @click="delModel(props.row, props.row.name)">
                            <icon name="remove"></icon>
                        </button>
                        <button class="btn btn-xs btn-primary" @click="updateModel(props.row)">
                            <icon name="edit"></icon>
                        </button>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>




// WEBPACK FOOTER //
// src/pages/Questions.vue